import Http from '@/support/http';

import S from '@/support/string';

export default {
	newAlbum(context, payload) {

		if (payload.scope === 'SCHOOL_CLASS') {
			payload.album.schoolClasses = [];

			payload.schoolClass.forEach(function(value) {
				payload.album.schoolClasses.push(value.schoolClassId);
			});

		} else if (payload.scope === 'STUDENT') {
			payload.album.students = [];

			payload.students.forEach(function(value) {
				payload.album.students.push(value.studentId);
			});
		}

		payload.album.scope = payload.scope;

		if (payload.userId) {

			const route = `v1/gallery/album/user/${payload.userId}`;

			return Http.post(route, payload.album).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response.data;

			});
		}
	},
	editAlbum(context, payload) {

		if (payload.userId) {

			const route = `v1/gallery/album/${payload.album.id}/user/${payload.userId}`;

			return Http.put(route, {
				title: payload.album.title,
				description: payload.album.description
			}).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response.data;

			});

		}

	},
	getAlbumList(context, payload) {

		if (payload.userId) {

			const route = `v1/gallery/album/user/${payload.userId}?quantity=${payload.pagination.quantity}&page=${payload.pagination.page}`;

			return Http.get(route).then((response) => {

				context.commit('SET_ALBUM_LIST', response.data);

				return response.data;

			});
		}
	},
	setAlbum(context, payload) {

		if (payload.userId && payload.id) {

			const route = `v1/gallery/user/${payload.userId}?albumId=${payload.id}`;

			return Http.get(route).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response.data;

			});
		}
	},
	setUpload(context, payload) {
		if (payload) {

			context.commit('SET_UPLOAD', payload);

			return payload;

		}
	},
	setAlbunsList(context, payload) {

		const queryString = S.makeQueryString(payload);

		if (payload.userId) {

			return Http.get(`v1/gallery/album/user/${payload.userId}${ queryString }`).then((response) => {

				context.commit('SET_ALBUM_LIST', response.data);


				return response;

			});
		}
	},
	publishAlbum(context, payload) {

		if (payload.userId) {

			return Http.post(`v1/gallery/album/${payload.id}/user/${payload.userId}/publish`).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response;

			});
		}
	},
	unpublishAlbum(context, payload) {

		if (payload.userId) {

			return Http.post(`v1/gallery/album/${payload.id}/user/${payload.userId}/unpublish`).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response;

			});
		}
	},
	unpublishPhotos(context, payload) {

		if (payload.userId) {
			return Http.post(`v1/gallery/album/${payload.id}/user/${payload.userId}/unpublish`, {
				'photos': payload.photos
			}).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response;

			});
		}

	},
	publishPhotos(context, payload) {

		if (payload.userId) {
			return Http.post(`v1/gallery/album/${payload.id}/user/${payload.userId}/publish`, {
				'photos': payload.photos
			}).then((response) => {

				context.commit('SET_ALBUM', response.data);

				return response;

			});
		}

	},
	setInfoPhoto(context, payload) {

		if (payload.id && payload.userId) {

			const route = `v1/gallery/${payload.id}/user/${payload.userId}`;

			return Http.put(route, payload.infoPhoto).then((response) => {

				context.commit('SET_PHOTO', response.data);

				return response.data;

			});
		}
	},
	removePhoto(context, payload) {
		if (payload.userId) {
			return Http.delete(`v1/gallery/${payload.id}/user/${payload.userId}`).then((response) => {

				return response;

			});
		}
	},
	putAssignPhotoUsers(context, payload) {

		if (payload.userId && payload.albumId) {

			const route = `v1/gallery/album/${payload.albumId}/user/${payload.userId}/selection`;

			let imgSelect = {
				photos: [],
				schoolClasses: [],
				students: []
			};

			payload.photos.forEach((value) => {
				imgSelect.photos.push(value.id);
			});

			if (payload.schoolClass) {
				payload.schoolClass.forEach((value) => {
					imgSelect.schoolClasses.push(value.schoolClassId);
				});
			}
			if (payload.students) {
				payload.students.forEach((value) => {
					imgSelect.students.push(value.studentId);
				});
			}
			imgSelect.scope = payload.scope;

			return Http.put(route, imgSelect).then((response) => {

				return response;

			});
		}

	},
	cleanAlbum(context) {
		context.commit('SET_ALBUM', '');
	}
};



// WEBPACK FOOTER //
// ./sources/app/gallery/actions.js